import { Field, change } from 'redux-form';

import { Input, InputWithIcon, AutoCompleteSelect } from '../../../../../../itrust_common/components/form';
import { useCurrentTypeHook } from '../../../../../../itrust_common/components/others/helperHooks/useCurrentTypeHook';

import DiscountField from '../../DiscountField';
import { connect } from 'react-redux';
import WarrantyShieldIcon from '../../warranty/WarrantyShieldIcon';

let Frame = props => {
  const { member, currentEyeglass, pprops, orderStoreId, taxSettings } = props;
  const currency = useCurrentTypeHook();

  function handleAddRandomBrand(randomBrand, handleAutoCompleteSelectState) {
    if (currentEyeglass.frame_id) {
      handleAutoCompleteSelectState({ selectedData: [] })
      pprops.dispatch(change('orderEyeglassForm', `${member}[frame_id]`, null))
      pprops.dispatch(change('orderEyeglassForm', `${member}[frame_details][brand]`, randomBrand))
      setTimeout(() => pprops.submit(), 500)
    }
    else {
      pprops.dispatch(change('orderEyeglassForm', `${member}[frame_details][brand]`, randomBrand))
      setTimeout(() => pprops.submit(), 500)
    }
  }

  const getStoreIdForSearch = () => {
    let StoreId = localStorage.getItem('StoreID')
    if (!StoreId && StoreId == null) {
      return orderStoreId
    }
    return StoreId
  }



  return (
    <div className="row mx-0 mb-7 bg-light">
      <div className="col-12 p-5">
        <h6 className="d-inline-flex align-items-center mb-0">
          Frame
          <WarrantyShieldIcon warranty={currentEyeglass?.warranty_attributes} covers="frame" />
        </h6>
      </div>

      <Field
        name={`${member}[frame_id]`}
        displayName={`${member}[frame_details][brand]`}
        component={AutoCompleteSelect}
        onChangeHook={(data) => { pprops.dispatch(change('orderEyeglassForm', `${member}[frame_id]`, data.id)); setTimeout(() => pprops.submit(), 500) }}
        klass="Settings::EyeglassLensFrame"
        additionalFilters={{ store_inventory: getStoreIdForSearch() }}
        textField="brand"
        valueField="id"
        placeholder="Placeholder"
        wrapperClasses="col-4 form-group"
        className="form-control"
        label={
          <span>Frame {currentEyeglass.frame_amount_on_hand !== null && <span className="badge badge-info badge-pill" style={{ height: 26 }}> {currentEyeglass.frame_amount_on_hand} </span>} </span>
        }
        labelClasses="w-100"
        showAddOption={true}
        addSearchValSubmit={(val, handleAutoCompleteSelectState) => handleAddRandomBrand(val, handleAutoCompleteSelectState)}
        isNilInputValue={true}
      />
      <Field name={`${member}[frame_unit_price]`} type="number" component={InputWithIcon} title={currency.symbol} label="Unit Price" labelClasses="w-100" className="form-control" wrapperClasses="col-2 form-group" onBlur={() => setTimeout(() => pprops.submit(), 500)} />
      <Field name={`${member}[frame_copay]`} component={InputWithIcon} title={currency.symbol} label="Copay" labelClasses="w-100" className="form-control" wrapperClasses="col-2 form-group" onBlur={() => setTimeout(() => pprops.submit(), 500)} />
      <div className="col-3">
        <label>Discount</label>
        <DiscountField
          itemId={currentEyeglass?.id}
          cashName={`${member}[frame_cash_discount]`}
          percentageName={`${member}[frame_percentage_discount]`}
          discountTypeName={`${member}[frame_discount_type]`}
          defaultType={currentEyeglass.frame_discount_type}
          prependClasses="py-2"
          onBlur={() => setTimeout(() => pprops.submit(), 500)}
        />
      </div>
      {((currentEyeglass?.frame_tax_percentage !== undefined && currentEyeglass?.frame_tax_percentage !== null)) && (
        <div className="col-3 pb-3">

          <div className="d-flex align-items-center">
            <div>
          <label className='text-nowrap'>Tax</label>
            <Field
              name={`${member}[frame_tax_percentage]`}
              type="number"
              component="input"
              className="form-control mr-1"
              style={{ width: '60px' }}
              disabled={!taxSettings.allow_item_tax_override}
              onBlur={() => setTimeout(() => pprops.submit(), 500)}
            />
            </div>
           <span className="mr-2 mt-7">%</span>
             <div>
            <label>Tax amount</label>
            <input
              type="text"
              className="form-control disabled bg-light"
              style={{ width: '80px' }}
              value={currentEyeglass?.frame_tax_amount !== undefined && currentEyeglass?.frame_tax_amount !== null ? parseFloat(currentEyeglass.frame_tax_amount).toFixed(2) : ''}
              readOnly
            />
            </div>
          </div>
        </div>
      )}

      <Field name={`${member}[frame_details][model]`} component={Input} label="Model" className="form-control" wrapperClasses="col-3 form-group" />
      <Field name={`${member}[frame_details][material]`} component={Input} label="Material" className="form-control" wrapperClasses="col-3 form-group" />
      <Field name={`${member}[frame_details][color]`} component={Input} label="Color" className="form-control" wrapperClasses="col-3 form-group" />
      <Field name={`${member}[frame_details][color_code]`} component={Input} label="Color Code" className="form-control" wrapperClasses="col-3 form-group" />
      <Field name={`${member}[frame_details][eye_size]`} component={Input} label="Eye Size / A" className="form-control" wrapperClasses="col-3 form-group" />
      <Field name={`${member}[frame_details][bridge]`} component={Input} label="Bridge / DBL" className="form-control" wrapperClasses="col-3 form-group" />
      <Field name={`${member}[frame_details][temple]`} component={Input} label="Temple" className="form-control" wrapperClasses="col-3 form-group" />
      <Field name={`${member}[frame_details][b_glass]`} component={Input} label="B" className="form-control" wrapperClasses="col-3 form-group" />
      <Field name={`${member}[frame_details][ed]`} component={Input} label="ED" className="form-control" wrapperClasses="col-3 form-group" />
      <Field name={`${member}[frame_details][promotion]`} component={Input} label="Promotion" className="form-control" wrapperClasses="col-3 form-group" readOnly disabled />
    </div>
  )
}

const mapStateToProps = (state) => {
  const { order: { order }, storeSetting } = state
  return {
    orderStoreId: order.store_id,
    taxSettings: storeSetting?.filtered_store_settings?.tax_settings?.[0]?.store_config || {}
  }
}

export default connect(mapStateToProps)(Frame);